import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';
import { selectHasAnyAccess } from '../state/user/user.selectors';

/**
 * Route data: `{ roles?: string[]; privileges?: string[] }`
 * Access is granted when the user has any listed role OR privilege.
 */
export const roleGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);

  const requiredRoles = (route.data['roles'] as string[] | undefined) ?? [];
  const requiredPrivileges = (route.data['privileges'] as string[] | undefined) ?? [];

  if (requiredRoles.length === 0 && requiredPrivileges.length === 0) {
    return true;
  }

  return store.select(selectHasAnyAccess(requiredRoles, requiredPrivileges)).pipe(
    take(1),
    map((allowed) =>
      allowed ? true : router.createUrlTree(['/app'], { queryParams: { denied: '1' } }),
    ),
  );
};
